export const Highlight = () => {
  const baseClassNames: string =
    "absolute min-w-full min-h-full bg-gray-50 -inset-px overflow-hidden"

  return (
    <div className={baseClassNames}>
      <div className="absolute w-full h-full -left-full bg-highlight animate-highlight-move" />
    </div>
  )
}
